import * as React from "react"
import { Grid } from "@mui/material"
import {string, object, array} from "yup";
import { DrawerSeeker, TextFieldSeeker, SelectSeeker, TagFieldSeeker } from "@ui-seeker/core"
import { useAppToast, useValidatorSeeker } from "@ui-seeker/app"
import { isEmpty } from '@ui-seeker/utils'

import { flashOffersReportDrawerIsOpen } from "../@signals";
import { useCustomDashboardsPrimorFlashOffersReportForm } from "../@hooks";


export default function FlashOffersFormDrawer() {
	const { showToast } = useAppToast()
	const { handleSendToBack, nameReport, emailsReport, resetFormData } = useCustomDashboardsPrimorFlashOffersReportForm()

	const validatorData = useValidatorSeeker({
        nameReport: nameReport.value,
        emailsReport: emailsReport.value,
    }, object({
        nameReport: string().required('Report name must be provided'),
        emailsReport: array().min(1, 'At least 1 email is required')
    }))

	if (!flashOffersReportDrawerIsOpen.value) return <></>
	
    return <DrawerSeeker
		isOpen={flashOffersReportDrawerIsOpen.value}
		controller={() => {
			flashOffersReportDrawerIsOpen.value = false
			resetFormData()
		}}
		title={`Create New Flash Offers Report`}
		width="40%"
		successProps={{ onClick: isEmpty(validatorData.errors)
			? handleSendToBack
			: () => showToast.warning('Please ensure all mandatory fields are completed ') 
		}}
	>
    	<Grid container spacing={3}>
			<Grid item xs={12}>
				<TextFieldSeeker
					error={validatorData.errors?.nameReport}
					label="Report Name"
					size="small"
					fullWidth
					value={nameReport.value}
					onChange={e => nameReport.value = e.target.value}
					icon="pen-to-square"
				/>
			</Grid>

			<Grid item xs={12}>
				<TagFieldSeeker
					error={validatorData.errors?.emailsReport}
					value={emailsReport.value}
					fullWidth
					onChange={e => emailsReport.value = e }
					label="Emails"
					placeholder="Enter to add emails"
				/>
			</Grid>

		</Grid>
    </DrawerSeeker>
}